import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEyeOpen"><Path d="M2 12C6.82745 2.00007 17.1725 1.99995 22 11.9999C17.1725 21.9999 6.82745 22 2 12Z" stroke="currentColor" strokeLinecap="round"/><Path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconEyeOpen;
